module.exports = new __parcel__URL__("eth.77f0cd7e.svg").toString();